import type { PriceId } from '@iheartjane/types';
import { useLocation } from 'react-router';

export interface ProductDetailsPathArgs {
  isCartTopper?: true;
  isInlineAd?: boolean;
}

export const useProductDetailsPath = ({
  isCartTopper,
  isInlineAd,
}: ProductDetailsPathArgs = {}) => {
  const { pathname } = useLocation();

  return (productId: number, priceId?: PriceId) => {
    const queryParams = new URLSearchParams({
      priceId: priceId ?? '',
      ...(isCartTopper ? { topper: 'true' } : {}),
      ...(isInlineAd ? { inline: 'true' } : {}),
      pdpDepth: '1',
    });

    return `${pathname}/products/${productId}?${queryParams.toString()}`;
  };
};
